import { render, staticRenderFns } from "./listing-newbox.vue?vue&type=template&id=3acc4892&"
import script from "./listing-newbox.vue?vue&type=script&lang=js&"
export * from "./listing-newbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports